import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationService } from '@mydocma/component-library/src/lib/notification';
import { PR_ERROR_MESSAGES } from '../models/pr-error-code';

export enum NOTIFICATION_TYPE {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}
@Injectable({ providedIn: 'root' })
export class ErrorHandlingService {
  constructor(private readonly notificationService: NotificationService) {}

  trimPrPrefix(errorCode: string | number): number | null {
    if (typeof errorCode === 'string' && errorCode.startsWith('PR-')) {
      const num = Number(errorCode.replace('PR-', ''));
      return isNaN(num) ? null : num;
    }
    if (typeof errorCode === 'number') {
      return errorCode;
    }
    return null;
  }

  handle(
    error: any,
    fallbackMessage?: string,
    showNotification: boolean = true,
    notificationType: NOTIFICATION_TYPE = NOTIFICATION_TYPE.ERROR,
  ): void {
    let message = fallbackMessage;
    let errorCode = '';
    let statusCode = '';

    if (error instanceof HttpErrorResponse) {
      statusCode = error.status?.toString() || '';
      if (error.error) {
        message = fallbackMessage || 'An error occurred.';
        errorCode = error.error.errorCode || '';
        if (errorCode && PR_ERROR_MESSAGES[errorCode]) {
          message = PR_ERROR_MESSAGES[errorCode];
        }
      }
    } else if (error?.errorCode && PR_ERROR_MESSAGES[error.errorCode]) {
      message = PR_ERROR_MESSAGES[error.errorCode];
      errorCode = error.errorCode;
    } else if (typeof error === 'string') {
      message = error;
    }

    if (showNotification) {
      this.notificationService[notificationType](message);
    }
  }
}
